import React from 'react'
import clsx from 'clsx'
import { ArrowLeft2, ArrowRight2 } from 'iconsax-react'

import { useTaskList } from '../../../providers/TaskListProvider'
import { useBreakpoint } from '../../../providers/BreakpointProvider'
import useStyles from './styles'

const TaskArrows = ({ onChange, modal }) => {
  const { canScrollLeft, canScrollRight, moveForward, moveBackward } =
    useTaskList()
  const { isMedium } = useBreakpoint()

  const [height, setHeight] = React.useState(false)

  const classes = useStyles({ modal, onMobile: isMedium, height })

  // Decides whether the buttons should be at half screen height or just middle of the details
  const checkFloating = React.useCallback(() => {
    const details = document.querySelector('#task-details')
    const { top, bottom, height } = details.getBoundingClientRect()
    const docHeight = document.body.offsetHeight

    let trueTop = 0
    if (top > 0) {
      trueTop = 0
    } else {
      trueTop = -top
    }
    let trueBot = 0
    if (bottom > docHeight) {
      trueBot = docHeight - top
    } else {
      trueBot = height
    }
    const mid = trueTop + (trueBot - trueTop) * 0.5
    setHeight(mid)
  }, [])

  // Checks if the buttons should float when screen size changes
  React.useEffect(() => {
    if (modal || (!canScrollLeft && !canScrollRight)) {
      return
    }

    checkFloating()

    window.addEventListener('resize', checkFloating)
    const elem = document.querySelector('#root > div')
    elem.addEventListener('scroll', checkFloating)

    return () => {
      window.removeEventListener('resize', checkFloating)
      elem.removeEventListener('scroll', checkFloating)
    }
  }, [modal, checkFloating, canScrollLeft, canScrollRight])

  if (!canScrollLeft && !canScrollRight) {
    return null
  }

  return (
    <>
      {canScrollLeft ? (
        <ArrowLeft2
          onClick={() => moveBackward(onChange)}
          className={clsx(classes.arrow, classes.leftArrow)}
        />
      ) : (
        <div />
      )}

      {canScrollRight ? (
        <ArrowRight2
          onClick={() => moveForward(onChange)}
          className={clsx(classes.arrow, classes.rightArrow)}
        />
      ) : (
        <div />
      )}
    </>
  )
}

export default TaskArrows
